import React, { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Keep the original Spanish-language experience and block browser translation.
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'MEGAPACK COMERCIO PRO';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'MEGAPACK COMERCIO PRO: 6 Tomos + 6 Bonos estratégicos. Sistema completo para vender, rankear y escalar en Mercado Libre Argentina.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: 'https://cdn.magicpatterns.com/uploads/4p7HE5ixBSKoBh4AAubvnx/MOckup_sin_fondo.png',
      // @ts-ignore
      fetchpriority: 'high'
    });
    // Performance: warm up the checkout connection so CTA clicks navigate instantly.
    // TCP + TLS to centershop.store happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://centershop.store'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://centershop.store',
      crossorigin: ''
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandYellow selection:text-brandNavy notranslate" data-id="element-0" data-mp="1r498zrn45uuy">
      <MetaPixel data-id="element-1" data-mp="1w19d3x0eknjf" />
      <SocialProofPopup data-id="element-2" data-mp="1i3ktesi2nmfy" />
      <Hero data-id="element-3" data-mp="1i4cevahyg3si" />
      <SocialProof data-id="element-4" data-mp="1i2j8zxf61nlk" />
      <Testimonials1 data-id="element-5" data-mp="1i3b2n2p7db97" />
      <Problem data-id="element-6" data-mp="1i5x7uvomfeo9" />
      <ProductTomos data-id="element-7" data-mp="1m4wa28iywxc0" />
      <Bonuses data-id="element-8" data-mp="1m4egxkrlqz8b" />
      <UrgencyCounter data-id="element-9" data-mp="1m3uym2y1i8tr" />
      <Pricing data-id="element-10" data-mp="1m3cwwqslz2eg" />
      <Potenciador data-id="element-11" data-mp="1m70pnnq8bks4" />
      <Testimonials2 data-id="element-12" data-mp="6onu8ps6bguv" />
      <Guarantee data-id="element-13" data-mp="6ncmyfzirqz0" />
      <FAQ data-id="element-14" data-mp="6mujayaj2ah2" />
      <CostOfNotHaving data-id="element-15" data-mp="6n4auqb80pov" />
      <FinalCTA data-id="element-16" data-mp="aq0xcs3vt5y3" />
      <Footer data-id="element-17" data-mp="aqiqhfv8z41s" />
    </div>;
}